// SPDX-FileCopyrightText: 2024 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
export async function extractLabels(base64): Promise<number[]> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = base64;

    img.onload = () => {
      // create canvas
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = img.width;
      canvas.height = img.height;
      ctx!.drawImage(img, 0, 0);

      // extract image data
      const imageData = ctx!.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;

      // initialize histogram
      const histogram = new Set<number>();

      // iterate through all pixels and collect values
      for (let i = 0; i < data.length; i += 4) {
        const r = data[i]; // R-value

        histogram.add(r);
      }

      // convert Set to Array and resolve
      resolve(Array.from(histogram));
    };

    img.onerror = () => reject(new Error('Failed to load image.'));
  });
}
